import {useForm} from 'react-hook-form'
import {useCallback} from 'react'
import {useParams} from 'react-router-dom'

import PageTitle from '../../common/PageTitle'
import {FormProvider} from '../../common/hook-form'
import withLayout from '../../hocs/Layout'
import BusinessType from './BusinessType'
import Documents from './Documents'

function Kyc() {
  const {step} = useParams()

  const methods = useForm({
    defaultValues: {
      businessType: '',
      accountType: 'postpaid',
    },
    mode: 'onChange',
  })

  const {handleSubmit} = methods

  const onSubmit = useCallback((data) => {
    console.log('Form submitted:', data)
  }, [])

  return (
    <div id='main-content' className='container-fluid'>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <PageTitle>Seller Verification</PageTitle>
        {step === 'business-type' && <BusinessType />}
        {step === 'document-upload' && <Documents />}
      </FormProvider>
    </div>
  )
}

export default withLayout(Kyc)
